import React from "react";
import PropTypes from "prop-types";
import { Text as TextRaw } from "@designbycosmic/cosmic-react-common-components";

// Pass default options for common text elements accross the various
// style attributes: font, size, style (bold/italic), line-height, letter-spacing
// Note: styles are defined in the tailwind.config.js file

const config = {
  typography: {
    h1: {
      font: "font-header",
      size: "text-xl",
      lineHeight: "leading-1.1",
      style: "block",
    },
    label: {
      font: "font-label",
      size: "text-sm",
      lineHeight: "leading-1.1",
      letterSpacing: "tracking-wide",
      style: "block uppercase",
    },
    p: {
      font: "font-body",
      size: "text-body",
      lineHeight: "leading-1.8",
      style: "block",
    },
    span: {},
  },
};

// All headers use same style
config.typography.h2 = config.typography.h1;
config.typography.h3 = config.typography.h1;

const Text = ({ className = "", style = {}, children, ...textProps }) => {
  if (!children) {
    return null;
  }

  return (
    <TextRaw
      className={`rich-text-content ${className}`}
      style={style}
      config={config}
      {...textProps}
      preserveWidows
    >
      {children}
    </TextRaw>
  );
};

Text.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
};

export const textConfig = config;
export default Text;
